<template>
  <div :class="previewMode ? '' : 'wf-border wf-p-2 wf-pt-0 wf-border-transparent hover:wf-border-gray-500 hover-trigger'">
    <div v-show="! previewMode" class="wf-relative wf-justify-end wf-flex">
      <button class="hover-target pricing-table-block-handle wf-text-gray-500"><i class="fas fa-arrows-alt"></i></button>
    </div>
    <ul :class="classes" :style="styles">
      <li class="wf-my-4 wf-flex wf-items-center hover-trigger" v-for="(item, index) in value" :key="index">
        <i :style="iconStyles" :class="iconClasses"></i>
        <div :contenteditable="! previewMode" @input="updateItem(index, $event)" v-text="item.title"></div>
        <button
          v-show="! previewMode && value.length > 1"
          @click.prevent="removeItem(index)"
          class="hover-target wf-text-red-300 hover:wf-text-red-500 wf-ml-2"
        ><i class="fas fa-trash"></i></button>
      </li>
      <li v-show="! previewMode">
        <button
          @click.prevent="addItem"
          class="focus:wf-outline-none wf-h-10 wf-border wf-border-gray-500 wf-border-dashed wf-w-full wf-text-gray-500 wf-uppercase wf-text-xs wf-text-center wf-font-bold"
        >add list item</button>
      </li>
    </ul>
  </div>
</template>

<script>
  import _ from 'lodash'
  import PricingTableBlock from '../contracts/PricingTableBlock'
  export default PricingTableBlock.extend({
    props: {
      value: {
        type: Array,
        required: true,
      },
      iconClasses: {
        type: [Array, String],
        requried: false,
        default: () => []
      },
      iconStyles: {
        type: [Object, String],
        requried: false,
        default: () => []
      },
    },
    methods: {
      newListItem() {
        return { title: 'New List Item' }
      },
      removeItem(index) {
        let listItems = ([...this.value]).filter((item, itemIndex) => itemIndex != index)
        this.$emit('input', listItems)
      },
      addItem() {
        let listItems = [...this.value, this.newListItem()]
        this.$emit('input', listItems)
      },
      updateItem: _.debounce(function(index, {target}) {
        let listItems = ([...this.value]).map((item, itemIndex) => ({
          title: index == itemIndex ? target.textContent : item.title
        }))
        this.$emit('input', listItems)
      }, 1000)
    }
  })
</script>